export default "__VITE_ASSET__DKki5Tjh__"